import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-control-buttons',
  templateUrl: './control-buttons.component.html',
  styleUrls: ['./control-buttons.component.scss']
})
export class ControlButtonsComponent implements OnInit {
  @Output() edit = new EventEmitter<any>();
  @Output() duplicate = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  onEdit(event: any) {
    event.preventDefault();
    event.stopPropagation();

    this.edit.emit();
  }

  onDuplicate(event: any) {
    event.preventDefault();
    event.stopPropagation();

    this.duplicate.emit();
  }

  onDelete(event: any) {
    event.preventDefault();
    event.stopPropagation();

    this.delete.emit();
  }

}
